(() => {
  const roots = document.querySelectorAll('[id^="PacPurchase-"]');

  roots.forEach((root) => {
    if (root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    const image = root.querySelector('[data-gallery-image]');
    const label = root.querySelector('.sp-gallery-footer > [data-gallery-label]');
    const count = root.querySelector('[data-gallery-count]');
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const previous = root.querySelector('.sp-gallery-arrow-left');
    const next = root.querySelector('.sp-gallery-arrow-right');
    const variantOptions = Array.from(root.querySelectorAll('.variant_option'));

    if (!image || thumbs.length === 0) return;

    let currentIndex = 0;

    const syncVariantState = () => {
      variantOptions.forEach((variantOption) => {
        const input = variantOption.querySelector('.productOption');
        variantOption.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    };

    const show = (index) => {
      currentIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[currentIndex];

      image.classList.add('is-changing');
      image.src = thumb.dataset.gallerySrc;
      image.alt = thumb.dataset.galleryAlt;

      if (label) label.textContent = thumb.dataset.galleryLabel;
      if (count) {
        count.textContent = `${String(currentIndex + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
      }

      thumbs.forEach((entry, entryIndex) => {
        const selected = entryIndex === currentIndex;
        entry.classList.toggle('is-active', selected);
        entry.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      requestAnimationFrame(() => image.classList.remove('is-changing'));
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    if (previous) previous.addEventListener('click', () => show(currentIndex - 1));
    if (next) next.addEventListener('click', () => show(currentIndex + 1));

    root.addEventListener('change', (event) => {
      if (!event.target.closest('.productOption')) return;
      syncVariantState();
    });

    syncVariantState();
  });
})();
